$(document).ready(() => {
    clickTestiomonials()
});

if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
        clickTestiomonials();
    });
}

function clickTestiomonials() {
    $(".new-testimonials-arrows > button").on("click", (e) => {
        var el = e.currentTarget;
        var container = $(el).parent()[0];
        var sectionId = $(container).attr("data-section-id");
        var direction = $(el).hasClass("new-testimonials-arrow-left") ? -1 : 1;
        var testimonialsContainer = $(".new-testimonials-content-" + sectionId)[0];
        var testimonials = $(testimonialsContainer).find('.new-testimonial');
        var testimonialsContainerOffset = $(testimonialsContainer).scrollLeft();
        var testimonialsWidth = getWidth_wm(testimonials[0]);
        var fractionOffset = (testimonialsContainerOffset / testimonialsWidth) % 1;
        if (direction > 0) {
            fractionOffset = (1 - fractionOffset);
            if (Math.round(fractionOffset) == 0) {
                fractionOffset = 1;
            }
        } else {
            if (fractionOffset == 0) {
                fractionOffset = 1;
            }
        }
        $(testimonialsContainer).animate({ scrollLeft: testimonialsContainerOffset + direction * testimonialsWidth * fractionOffset }, 200);
    });
}

function getWidth_wm(theDiv) {
    theDiv = $(theDiv);
    var totalWidth = theDiv.width();
    totalWidth +=
        parseInt(theDiv.css("padding-left"), 10) +
        parseInt(theDiv.css("padding-right"), 10);
    totalWidth +=
        parseInt(theDiv.css("borderLeftWidth"), 10) +
        parseInt(theDiv.css("borderRightWidth"), 10);
    return totalWidth;
}